import { useCallback, useState } from 'react';

import { ServiceUploadingOptions } from '@/utils/shared/uploadProgress';

type SubmitWithUploading<T> = (
  data: T,
  options: ServiceUploadingOptions,
) => Promise<unknown>;

export default function useUploading<T>(submit: SubmitWithUploading<T>) {
  const [uploadProgress, setUploadProgress] = useState<number | null>(null);

  const handleSubmit = useCallback(
    async (data: T) => {
      try {
        await submit(data, { onUploadProgress: setUploadProgress });
      } finally {
        setUploadProgress(null);
      }
    },
    [submit],
  );

  return { uploadProgress, handleSubmit };
}
